export function movetop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }